import { render } from "./MediumTile.vue?vue&type=template&id=bf6a9360&scoped=true"
import script from "./MediumTile.vue?vue&type=script&lang=js"
export * from "./MediumTile.vue?vue&type=script&lang=js"

import "./MediumTile.vue?vue&type=style&index=0&id=bf6a9360&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf6a9360"]])

export default __exports__